import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@material-ui/core';

export const Account: FC = () => (
  <Box
    sx={{
      backgroundColor: 'background.default',
      flexGrow: 1,
      pt: 2
    }}
  >
    <Outlet />
  </Box>
);
